import { TableCell, TableRow } from "@mui/material";
import React, { useEffect, useState } from "react";
import dele from "../../../assets/DigitalMarketing/image/delete.svg";
import edit from "../../../assets/DigitalMarketing/image/edit.svg";
import AlertDialog from "../../../Component/DigitalMarketing/deleteConfirmation";
import IosSwitchBtn from "../../../Component/DigitalMarketing/IosSwitchbtn";
import {
  useDeleteCarePackageMutation,
  useUpdateCarePackageMutation,
  useUpdateCarePackageStatuseMutation,
} from "../../../Service/CarePackages";
import useDeleteBox from "../../../hooks/digitalMarketing/useDeleteBox";
import useSnackbar from "../../../hooks/digitalMarketing/useSnackbar";

const TableList = (props) => {
  const {
    activeIndex,
    setUpdateData,
    setShow,
    setDeleted,
    carepackageData = { data: [] },
    assignmenthistoryData = { data: [] },
    refetch, // Function to refresh data
  } = props;

  const [checkedStates, setCheckedStates] = useState([]);
  const [setOpen] = useState(false);
  const { open, message, openSnackBar, type } = useSnackbar();

  const [updateCarePackage] = useUpdateCarePackageMutation(); // Update API hook
  const [deleteCarePackage] = useDeleteCarePackageMutation(); // Delete API hook
  const [updateCarePackageStatuse] = useUpdateCarePackageStatuseMutation(); // Status update API hook

  const handleChange = (index: any, id: number) => (event) => {
    const newCheckedStates = [...checkedStates];
    newCheckedStates[index] = event?.target?.checked;
    setCheckedStates(newCheckedStates);

    updateStatus(id, event.target.checked);
  };

  const updateStatus = async (id, status) => {
    await updateCarePackageStatuse({ id, activeStatus: status ? "1" : "0" }).unwrap();
    refetch();
  };

  const handleUpdate = (data: any) => {
    setShow(true);
    setUpdateData(data);
  };

  // Handle delete confirmation

  const {
    open: open1,
    message: message1,
    openDelete,
    deleteId,
  } = useDeleteBox();

  const Delete = async (bool) => {
    if (bool) {
      try {
        const payload = await deleteCarePackage(deleteId).unwrap();
         refetch();
        openSnackBar("Deleted successfully"); // Show success snackbar
       
        setDeleted(true); 
        
      } finally {
        openDelete(
          "Are you sure you want to delete this care package?",
          false,
          null
        ); // Close dialog box after operation
      }
    } else {
      openDelete(
        "Are you sure you want to delete this care package?",
        false,
        null
      ); // Close dialog box if cancelled
    }
  };

  // Initialize toggle states
  useEffect(() => {
    const data = activeIndex === 1 ? carepackageData : assignmenthistoryData;
    if (data?.data) {
      setCheckedStates(data.data.map((a) => a?.activeStatus === 1));
    }
  }, [activeIndex, carepackageData, assignmenthistoryData]);

  return (
    <>
      {/* Delete Confirmation Dialog */}
      <AlertDialog open={open1} message={message1} deleteBranches={Delete} />

      {/* Care Packages Table */}
      {activeIndex === 1 &&
        carepackageData?.data?.map((a, index) => (
          <TableRow key={a.id} role="checkbox">
            <TableCell align="left">{index + 1}</TableCell>
            <TableCell align="left">{a.packageName}</TableCell>
            <TableCell align="left">{a.price}</TableCell>
            <TableCell align="left">{a.discount}</TableCell>
            <TableCell align="left">{a.validityPeriod}</TableCell>
            <TableCell align="left">
              <IosSwitchBtn
                 onChange={handleChange(index, a.id)}
                 checked={
                   checkedStates[index] !== undefined
                     ? checkedStates[index]
                     : false
                 }
                 label={checkedStates[index] ? "Active" : "Inactive"}
              />
            </TableCell>
            <TableCell align="left">
              <img
                src={edit}
                alt="edit"
                className="blue-c action-icon cursur"
                onClick={() => handleUpdate(a)}
              />
              <img
                src={dele}
                alt="delete"
                className="delete-icon cursur action-icon ms-2"
                onClick={() =>
                  openDelete(
                    "Are you sure you want to delete this care packages?",
                    true,
                    a.id
                  )
                }
              />
            </TableCell>
          </TableRow>
        ))}
      {activeIndex === 2 &&
        assignmenthistoryData?.data?.map((a, index) => (
          <TableRow key={a.id} role="checkbox">
            <TableCell align="left">{index + 1}</TableCell>
            <TableCell align="left">{a.customerName}</TableCell>
            <TableCell align="left">{a.caseId}</TableCell>
            <TableCell align="left">{a.packageName}</TableCell>
            <TableCell align="left">{a.Phone1}</TableCell>
            <TableCell align="left">{a.city}</TableCell>
            <TableCell align="left">
              <IosSwitchBtn
                checked={checkedStates[index] || false}
                label={checkedStates[index] ? "Active" : "Inactive"}
              />
            </TableCell>
            <TableCell align="left">
              <img
                src={edit}
                alt="edit"
                className="blue-c action-icon cursur"
                onClick={() => handleUpdate(a)}
              />
              <img
                src={dele}
                alt="delete"
                className="delete-icon cursur action-icon ms-2"
                // onClick={() => handleDelete(a.id, "Assignment History")}
              />
            </TableCell>
          </TableRow>
        ))}
    </>
  );
};

export default TableList;
